import { render } from "./approval.vue?vue&type=template&id=04802d6e&scoped=true"
import script from "./approval.vue?vue&type=script&lang=js"
export * from "./approval.vue?vue&type=script&lang=js"

import "./approval.vue?vue&type=style&index=0&id=04802d6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04802d6e"]])

export default __exports__